import { InjectionToken } from '@angular/core';

export const INSPECTION_PDF_REPORT_BASE: InjectionToken<string> =
  new InjectionToken('INSPECTION_PDF_REPORT_BASE');
